enum EnumTxType {
    issue = 'Issue',
    redeem = 'Redeem',
    all = '',
}

export default EnumTxType